import { UNAVAILABLE } from '../../pages/custodian/custodianReviewLabels';

function Fact({ label, children }) {
  return (
    <div>
      <dt className="text-[11px] font-semibold uppercase tracking-wide text-eorig-muted">
        {label}
      </dt>
      <dd className="mt-0.5 text-sm text-eorig-ink">{children}</dd>
    </div>
  );
}

/**
 * Post-admission outcome. Renders only when admission_state is AUTHORITATIVE.
 * "Sealed" is shown only when an evidence bundle id was returned.
 * Receipt stays unavailable: the custodian package API does not return one.
 */
export function AdmittedVaultOutcome({
  admissionState,
  holder,
  vaultAssetId,
  evidenceBundleId,
}) {
  if (admissionState !== 'AUTHORITATIVE') return null;

  const sealed = Boolean(evidenceBundleId);
  const copyLabel =
    holder === 'CUSTODIAN'
      ? 'In the vault, held by the Custodian'
      : holder
        ? `In the vault, held by ${holder}`
        : 'In the vault';

  return (
    <section
      role="region"
      aria-label="Vault outcome"
      className="rounded-2xl border border-eorig-border border-l-4 border-l-eorig-navy-600 bg-white p-4 shadow-eorig-card sm:p-5"
    >
      <h3 className="text-sm font-semibold text-eorig-ink">Vault outcome</h3>
      <p className="mt-1 text-xs leading-relaxed text-eorig-muted">
        {sealed
          ? 'The authoritative copy is in the vault. The evidence bundle was sealed at admission.'
          : 'The authoritative copy is in the vault.'}
      </p>
      <dl className="mt-4 grid gap-3 sm:grid-cols-2 xl:grid-cols-3">
        <Fact label="Authoritative copy">{copyLabel}</Fact>
        <Fact label="Vault asset">
          <span className="font-mono text-[13px]">{vaultAssetId || UNAVAILABLE}</span>
        </Fact>
        {sealed ? <Fact label="Vault seal">Sealed at admission</Fact> : null}
        <Fact label="Evidence bundle">
          {sealed ? (
            <>
              Created
              <span className="mt-1 block break-all font-mono text-[13px]">
                {evidenceBundleId}
              </span>
            </>
          ) : (
            UNAVAILABLE
          )}
        </Fact>
        <Fact label="Admission receipt">{UNAVAILABLE}</Fact>
      </dl>
    </section>
  );
}
